import React, { useEffect, useState } from "react";
import { TextField, Grid, Typography, Box } from "@mui/material";
import { PhotoCamera } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

type CustomProps = {
  name?: string;
  docTitle: string;
  path: string;
  height: number;
  width: number;
  show_message?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;

  // REMOVE IMAGE
  onRemove: () => void;
};

const CustomImagePicker: React.FC<CustomProps> = ({
  name,
  docTitle,
  path,
  height,
  width,
  show_message,
  onChange,
  onRemove,
}) => {
  const containerStyle: React.CSSProperties = {
    borderRadius: "20px",
    padding: "0px",
  };

  const imageContainerStyle: React.CSSProperties = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    border: "1px dashed #AFAFAF",
    padding: "22px",
    borderRadius: "20px",
    cursor: "pointer",
    width: "100%",
    height: "180px",
  };

  const imageStyle: React.CSSProperties = {
    width: "auto",
    height: "100%",
    borderRadius: "20px",
    objectFit: "cover",
  };

  const [message, setMessage] = useState("Drag to upload image");

  useEffect(() => {
    if (show_message) setMessage(show_message);
  }, [show_message]);

  return (
    <>
      <Box sx={containerStyle}>
        <Grid
          container
          spacing={0}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          
          <Grid item xs={12}>
            <label htmlFor={name}>
              <TextField
                id={name}
                type="file"
                name={name}
                onChange={onChange}
                InputProps={{
                  startAdornment: <PhotoCamera color="primary" />,
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "transparent",
                      },
                      "&:hover fieldset": {
                        borderColor: "transparent",
                      },
                    },
                  },
                }}
                fullWidth
                style={{ display: "none" }}
              />

              <Box component="div" sx={imageContainerStyle}>
                {!path ? (
                  <>
                    <img
                      src="upload.png"
                      style={{ width: "50px" }}
                      alt="upload"
                    />

                    <Typography
                      variant="body1"
                      color="textSecondary"
                      sx={{
                        textAlign: "center",
                        mt: "10px",
                        fontSize: "14px",
                        fontWeight: "300",
                        color: "#797979",
                      }}
                    >
                      {message}
                    </Typography>

                    <Typography
                      sx={{
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "300",
                        color: "#797979",
                      }}
                    >
                      or
                    </Typography>

                    <Box>
                      <Box
                        sx={{
                          background: "#DCD732",
                          fontSize: "14px",
                          fontWeight: "400",
                          marginTop: "7px",
                          color: "#000",
                          borderRadius: "4px",
                          padding: "5px 24px",
                          "&:hover": {
                            background: "#000",
                            color: "#fff",
                          },
                        }}
                      >
                        Browse
                      </Box>
                    </Box>
                  </>
                ) : (
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img src={path} alt="" style={imageStyle} />

                    {/* REMOVE IMAGE BUTTON */}
                    <Box
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onRemove();
                      }}
                      sx={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        background: "#fff",
                        borderRadius: "50%",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        fontSize: "16px",
                        "&:hover": {
                          background: "#f5f5f5",
                        },
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </Box>
                  </Box>
                )}
              </Box>
            </label>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          marginTop: "8px",
          fontSize: "14px",
          color: "#A5A5A5",
          fontWeight: "300",
          textAlign: "center",
        }}
      >
        {docTitle}
      </Box>
    </>
  );
};

export default CustomImagePicker;
